module.exports = __webpack_public_path__ + "static/media/wodehouse2.3da9dbb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/originals/wodehouse2.jpg
// module id = 126
// module chunks = 0